import { InfoModal, Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import {
  rootCss,
  modalContentWrapperCss,
  standardWrapperCss,
  standardLinkCss,
  standardDescriptionCss,
  hideFooterCss,
} from "./StandardsModal.style";

const propTypes = {
  standards: PropTypes.array,
  standardsLabel: PropTypes.string,
  setActive: PropTypes.func,
  modalProps: PropTypes.object,
};

const StandardsModal = ({
  standards,
  standardsLabel,
  setActive,
  modalProps,
}) => {
  return (
    <InfoModal
      labelId="Standards"
      onBackgroundClick={() => setActive(false)}
      title={standardsLabel}
      __cssFor={{
        root: rootCss,
        modalContentWrapper: modalContentWrapperCss,
        footer: hideFooterCss,
      }}
      {...modalProps}
    >
      {standards?.map(({ id, data }) => {
        return (
          <div css={standardWrapperCss} key={id}>
            <Anchor
              href={`${MONOLITH_ORIGIN}/search/?standards=${id}`}
              isInline
              openInNewTab
              __cssFor={{
                root: standardLinkCss,
              }}
            >
              {data.name}
            </Anchor>
            <p css={standardDescriptionCss}>{data.standard_description}</p>
          </div>
        );
      })}
    </InfoModal>
  );
};

StandardsModal.propTypes = propTypes;

export default StandardsModal;
